import { configureStore } from "@reduxjs/toolkit";
import logger from "redux-logger";
import { logout } from "./features/authVerification/authSlice";
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import appReducer from "./rootReducer";
import storage from "redux-persist/lib/storage/session";

const persistConfig = {
  key: "root",
  storage,
  blacklist: ["auth", "timer", "fullscreen", "audio", "warning", "snapshot"],
};

//reset all state on logout
const rootReducer = (state, action) => {
  if (logout.match(action)) {
    // for all keys defined in your persistConfig(s)
    console.info("logout was called");
    storage.removeItem("persist:root");
    storage.removeItem("persist:auth");
    storage.removeItem("persist:timer");
    storage.removeItem("persist:snapshot");
    storage.removeItem("persist:fullscreen");
    const newState = {
      auth: {
        token: null,
        loading: false,
        userData: null,
        repeatTimeOutId: null,
        loginCount: state.auth.loginCount,
      },
      candidateAuth: [],
      timer: {
        deductionTime: 0,
        examStarted: false,
        examEnded: false,
        cam1Start: false,
        cam2Start: false,
        submitShow: false,
        faceAPIloaded: false,
        counterIntervalId: null,
        randomize: null,
        timeCount: 0,
        times: {
          startTime: null,
          expiryTime: null,
        },
        _persist: {
          version: -1,
          rehydrated: false,
        },
      },
      examDetail: {
        details: null,
        activity: null,
        examPlan: "basic",
        submitted: false,
        submissionError: false,
        submissionLoading: false,
        showFeedBack: false,
      },
      audio: {
        isAudioRecording: false,
        isVoiceDetected: false,
        isEnvNoiseDetected: false,
        recordedLongSound: 0,
        longSoundTimeInSecs: 30,
        longSoundCounter: 0,
        lagTimeInSecs: 3,
        audioLog: {},
        vadOptions: {
          fftSize: 512,
          bufferLen: 512,
          smoothingTimeConstant: 0.2,
          minCaptureFreq: 85,
          maxCaptureFreq: 255,
          noiseCaptureDuration: 1000,
          minNoiseLevel: 0.6,
          maxNoiseLevel: 0.9,
          avgNoiseMultiplier: 1.2,
          minSegmentLengthMS: 500,
          maxCaptureSeconds: 60,
          sampleRate: 48000,
        },
      },
      fullscreen: {
        isFullscreen: false,
        exitFullscreenCount: 0,
        _persist: {
          version: -1,
          rehydrated: false,
        },
      },
      snapshot: {
        currentNoOfSnapshots: 0,
        takeSnapshotReg: 0,
        takeSnapshotAbs: 0,
        showCount: 0,
        faceAbsencePeriod: 0,
        numberOfFaceAbsence: 0,
        isAbsent: false,
        snapshotLog: {},
        numberOfSnapShots: 10,
        _persist: {
          version: -1,
          rehydrated: false,
        },
      },
      warning: {
        warningList: [],
        alignFace: false,
        noOfMultiFace: 0,
        multiFaceLapseTimeInSec: 2,
        multiFace: false,
        multiFaceCount: 0,
      },
      questions: {
        list: [],
        noOfQuestions: 0,
        activeTab: "multichoice",
        hasTheory: true,
        hasMultiChoice: true,
        currentIndex: 0,
        loading: false,
      },
    };
    return appReducer(newState, action);
  }
  return appReducer(state, action);
};
const persistedReducer = persistReducer(persistConfig, rootReducer);

let devMiddlewares = [];
if (process.env.NODE_ENV === "development") {
  devMiddlewares.push(logger);
}

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat(devMiddlewares),
});

// export const store = configureStore({
//   reducer: {
//     candidateAuth:candidateAuthReducer,
//     timer:timerReducer,
//     audio:audioReducer,
//     fullscreen:fullscreenReducer,
//     snapshot:snapshotReducer,
//     warning:warningReducer
//   }
// })

export let persistor = persistStore(store);
